'use client'

import { Calendar, Fields, Greater_or_equal, Power, Sliders_vertical, Zap } from '@indxsearch/pixl'
import ConsoleFeature from './ConsoleFeature'

export default function BoostRulesSection() {
  return (
    <ConsoleFeature
      id="boost-rules"
      mirror
      eyebrow="Chosen, lifted, scheduled"
      title="Boost rules"
      lead="Lift the products you want seen first: top rated, best sellers, this season's campaign. Build a rule from your own fields, give it a strength, and let it start and stop on the dates you choose."
      href="https://docs.indx.co/http/BoostRules"
      main={{ name: 'boosts', alt: "The console's Boost rules: a Halloween campaign running now, and a Christmas one that starts on 20 November, each built from conditions on the catalogue's fields." }}
      second={{ name: 'boosts-rule', alt: 'A top rated rule: rating from 4.5 and at least 100 ratings.' }}
      features={[
        { icon: <Fields/>, label: 'Conditions on your own fields' },
        { icon: <Greater_or_equal/>, label: 'AND, OR and ranges' },
        { icon: <Sliders_vertical/>, label: 'Strength from low to high' },
        { icon: <Calendar/>, label: 'Start and end dates' },
        { icon: <Power/>, label: 'Switch a rule off, keep it' },
        { icon: <Zap/>, label: 'Live on the next search' },
      ]}
    />
  )
}
